import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getQuantity } from 'redux/cart/cart-selectors';

import AnchorLink from 'react-anchor-link-smooth-scroll';
import Icon from 'components/modules/Icon/Icon';

import { MenuItem, FormControl, Select } from '@mui/material';
import styled from '@emotion/styled';
import s from './Navigation.module.css';

const Quantity = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  // position: absolute;
  top: -7px;
  right: -12px;
  font-size: 12px;
  width: 20px;
  height: 20px;
  font-weight: 700;
  background-color: #fff;
  color: #00a082;
  border-radius: 50%;
`;

export default function Navigation() {
  const [age, setAge] = useState('Українська');
  const quantity = useSelector(getQuantity);

  const handleChange = event => {
    setAge(event.target.value);
  };
  return (
    <nav>
      <NavLink
        to="/"
        className={navData => (navData.isActive ? s.activeLink : s.link)}
      >
        Ecoservice
      </NavLink>
      <NavLink
        to="/containers"
        className={navData => (navData.isActive ? s.activeLink : s.link)}
      >
        Контейнери
      </NavLink>
      <AnchorLink href="#aboutUs" className={s.activeLink}>
        Про нас
      </AnchorLink>
      <AnchorLink href="#footer" className={s.activeLink}>
        Контакти
      </AnchorLink>
      <NavLink
        to="/cart"
        className={navData => (navData.isActive ? s.activeLink : s.link)}
      >
        <div className={s.cartWrap}>
          <p className={s.text}>Кошик</p>
          <Icon id="#cart" />
          {quantity && <Quantity>{quantity}</Quantity>}
        </div>
      </NavLink>
      <FormControl
        sx={{
          m: 1,
          width: 130,
          outline: '0px',
          border: '0px',
          borderRadius: 'none',
        }}
        size="small"
      >
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          value={age}
          label="Age"
          onChange={handleChange}
        >
          <MenuItem value="Українська">Українська</MenuItem>
          <MenuItem value="English">English</MenuItem>
        </Select>
      </FormControl>
    </nav>
  );
}
